// extracted by mini-css-extract-plugin
export default {"dialog":"SendCodePopup_dialog__z-Etc","dialogContent":"SendCodePopup_dialogContent__kyl4d","buttonsContaine":"SendCodePopup_buttonsContaine__Q7k4i"};